/** @jsx jsx */
import { jsx } from '@emotion/react';
import { Suspense } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import { FlexItem } from '../../flex';
import Fieldset from '../../fieldset';
import { childCss } from './element.css';

import lazyElementRenderers from '../element-util/lazy-element-renderers';

import {
  ELEMENT_TYPE__HEADER,
  ELEMENT_TYPE__DESCRIPTION,
  ELEMENT_TYPE__CANVAS,
  ELEMENT__SHAPE,
} from '../../../redux/constants';

const Element = (props) => {
  const {
    data,
    editable = false,
    phone = false,
    style = {},
    selectedElement = null,
    setSelectedElement = () => {},
  } = props;

  const isEditable = editable;
  const isStatic =
    [ELEMENT_TYPE__HEADER, ELEMENT_TYPE__DESCRIPTION, ELEMENT_TYPE__CANVAS].indexOf(data.type) !==
    -1;
  const isSelected = get(selectedElement, 'id') === data.id;
  const cssObj = phone ? { width: '100%' } : data.css;
  const childCssVal = (() => {
    const { patched, visible } = data;
    return childCss({
      editable: isEditable,
      hidden: !visible,
      patched,
      selectable: isEditable && isStatic,
      selected: isSelected && isStatic,
      wrapperIsSelectable: isEditable && !isStatic,
      wrapperIsSelected: isSelected && !isStatic,
    });
  })();
  const select = (event) => {
    if (!isEditable) return;
    event.stopPropagation();
    setSelectedElement(data.id);
  };
  const handleCanvasClick = (event) => isStatic && select(event);
  const handleWrapClick = (event) => select(event);
  const Renderrer = lazyElementRenderers[data.type];

  if (!Renderrer) return null;

  return (
    <FlexItem {...cssObj} style={{ ...style, ...cssObj }}>
      <div // eslint-disable-line
        css={childCssVal}
        id={data.id}
        onClick={handleCanvasClick}
      >
        <Fieldset className="wrapper" element="div" loose name={data.id} onClick={handleWrapClick}>
          <Suspense fallback={null}>
            <Renderrer {...props} editable={isEditable} />
          </Suspense>
        </Fieldset>
      </div>
    </FlexItem>
  );
};

Element.propTypes = {
  data: ELEMENT__SHAPE.isRequired,
  editable: PropTypes.bool,
  phone: PropTypes.bool,
  style: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  selectedElement: ELEMENT__SHAPE,
  setSelectedElement: PropTypes.func,
};

Element.defaultProps = {
  editable: false,
  phone: false,
  style: {},
  selectedElement: null,
  setSelectedElement: () => {},
};

export default Element;
